import styled from 'styled-components';
import { media, mediaQuery } from '../../common/styles/styleUtil';

export const SuggestionWrapper = styled.div`
  .search-list + .search-list {
    border-top: 1px solid #d2d6da;
    margin: 16px 11px 0 15px;
    padding-top: 16px;
    @media (${mediaQuery.tablet}) {
      margin: 16px 0 0 15px;
    }
  }
  position: absolute;
  margin: 0 auto;
  left: 0;
  right: 0;
  top: 54px;
  width: 96%;
  height: 330px;
  padding: 15px 0;
  background: #ffffff;
  border-radius: 3px;
  text-align: left;
  overflow-y: scroll;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3);
  @media (${mediaQuery.tablet}) {
    top: 55px;
    bottom: 0;
    height: 88vh;
    width: 100%;
  }
  ${media.xs`
     height: 83vh;
  `}
  .suggestion-block {
    .block-title {
      font-size: 12px;
      font-weight: 500;
      color: #87919d;
      margin-left: 15px;
      text-transform: uppercase;
    }
    .suggestion-item {
      .item-thumb {
        width: 65px;
        height: 40px;
        margin-right: -65px;
        float: left;
        img {
          width: 100%;
        }
      }
      .item-info-wrapper {
        .item-title {
          height: 40px;
          line-height: 40px;
          margin: 0 0 0 74px;
        }
      }
    }
  }
  .suggestion-item {
    overflow: hidden;
    padding: 5px 15px;
    line-height: 1.25;
    &:hover {
      background: #ecf6fd;
    }
    .item-icon {
      display: inline-block;
      width: 28px;
      margin-right: -28px;
      font-size: 28px;
      text-align: center;
      vertical-align: middle;
    }

    .item-info-wrapper {
      width: 100%;
      float: right;
      .item-title {
        margin: 0 0 0 40px;
        font-size: 16px;
        font-weight: 500;
        color: #333f48;
        line-height: inherit;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      .item-subtitle {
        margin: 2px 0 0 40px;
        font-size: 16px;
        color: #697684;
        font-weight: 300;
        line-height: inherit;
        text-transform: capitalize;
      }
    }
  }
`;

export const IconWrapper = styled.i`
  margin-top: 6px;
  svg {
    width: 20px;
  }
`;
